<template>
  <div v-if="isMobile() && getLogo && store && currentStoreDoc && !isWC()">
    <div
        :style="{ 'background-image': 'url(' + store.ProfileImage + ')', 'width' : '100%', 'height' : '100%', 'background-size' : 'cover' }"
        class="banner text-white position-relative"
    >
      <div class="company-logo">
        <router-link
            v-if="getLogo && showLogo && !isRolldStore()"
            :class="isGift && 'd-flex align-items-center justify-content-center'"
            :to="getHomePageUrl"
        >
          <div
              class="rounded-circle text-center d-flex align-items-center justify-content-center"
              style="width: 6rem; height: 6rem;">
            <img :src="getLogo" alt="logo" style="width: 80%;" @error="showLogoError"/>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {getCurrentDate, operatingHours} from "@/api/helpers/datetimeHelper";

export default {
  name: "shopBannerMobile",
  data() {
    return {
      showLogo: true,
      store: null,
    };
  },
  mounted() {
    this.store = this.selectedCompany
        ? this.selectedCompany
        : this.currentStoreDoc;
  },
  computed: {
    ...mapGetters([
      "isGift",
      "getloadedMenu",
      "currentStoreDoc",
      "selectedCompany",
      "hqDoc",
    ]),
    opening() {
      if (this.store.OperatingHours) {
        const now = getCurrentDate(this.store.TimezoneIanaFormat);
        return operatingHours(this.store.BlackoutDates, now, this.store.OperatingHours);
      }

      return null;
    },
    getHomePageUrl() {
      return this.isGift
          ? "/store/" + this.currentStoreDoc.ID + "/giftcards"
          : "/store/" + this.currentStoreDoc.ID;
    },
    getLogo() {
      if (!this.isRolldStore()) {
        return this.currentStoreDoc.Logo;
      }

      return this.hqDoc
          ? this.hqDoc.Logo
            : this.currentStoreDoc
              ? this.currentStoreDoc.Logo
                : "";
    },
    isEnablePreOrder() {
      return (
          this.selectedCompany.IsInOperation &&
          (this.selectedCompany.EnablePreoderForDelivery ||
              this.selectedCompany.EnablePreoderForPickup)
      );
    },
  },
  methods: {
    showLogoError() {
      this.showLogo = false;
    },
  },
}
</script>

<style scoped>

</style>